import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { startCase } from "lodash";
import OImage from "components/reusable/OImage";
import noImageFound from "../../assets/images/No-image-found.jpg";
import AuthContext from "context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";

const BlogView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { updatePageName } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    updatePageName(t("VIEW_BLOG"));
  }, []);

  const blog = location?.state;

  return (
    <>
      <div>
        <div className="bg-[#F9F9F9]">
          <div className="px-3 py-4">
            <div className="bg-white border border-[#E9EDF9] rounded-lg">
              <div className=" border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 ">
                <div className="col-span-2 flex flex-wrap  items-center" />
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                  <div className="sm:py-4 sm:px-2 py-2 px-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('TITLE')}:</strong>
                      <h6 className="text-gray-700">{blog?.title || ""}</h6>
                    </div>
                  </div>
                  
                  <div className="sm:py-4 sm:px-2 py-2 px-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('WRITER_NAME')}:</strong>
                      <h6 className="text-gray-700">{blog?.writer_name || "N/A"}</h6>
                    </div>
                  </div>
                  
                  <div className="sm:py-4 sm:px-2 py-2 px-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('POST_DATE')}:</strong>
                      <h6 className="text-gray-700">
                        {blog?.post_date ? dayjs(blog.post_date).format("MM-DD-YYYY") : "N/A"}
                      </h6>
                    </div>
                  </div>
                  
                  <div className="sm:py-4 sm:px-2 py-2 px-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('CATEGORIES')}:</strong>
                      <h6 className="text-gray-700">
                        {blog?.categories?.map(cat => cat.name).join(', ') || "N/A"}
                      </h6>
                    </div>
                  </div>

                  <div className="sm:py-4 sm:px-2 py-2 px-2 col-span-1 md:col-span-2 lg:col-span-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('META_TITLE')}:</strong>
                      <h6 className="text-gray-700">{blog?.metaTitle || "N/A"}</h6>
                    </div>
                  </div>

                  <div className="sm:py-4 sm:px-2 py-2 px-2 col-span-1 md:col-span-2 lg:col-span-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('META_DESCRIPTION')}:</strong>
                      <h6 className="text-gray-700">{blog?.metaDescription || "N/A"}</h6>
                    </div>
                  </div>

                  <div className="sm:py-4 sm:px-2 py-2 px-2 col-span-1 md:col-span-2 lg:col-span-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('KEYWORDS')}:</strong>
                      <h6 className="text-gray-700">{blog?.keywords || "N/A"}</h6>
                    </div>
                  </div>

                  <div className="sm:py-4 sm:px-2 py-2 px-2 col-span-1 md:col-span-2 lg:col-span-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('IMAGE')}:</strong>
                      <div className="mt-2">
                        <OImage 
                          src={blog?.blogImage} 
                          fallbackUrl={noImageFound} 
                          alt={blog?.title}
                          className="max-w-xs max-h-64 object-contain"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="sm:py-4 sm:px-2 py-2 px-7 col-span-1 md:col-span-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-4 text-lg">{t('DESCRIPTION')}:</strong>
                      <div
                        className="break-words prose max-w-none"
                        dangerouslySetInnerHTML={{
                          __html: blog?.description || "N/A",
                        }}
                      ></div>
                    </div>
                  </div>
                                    
                  <div className="sm:py-4 sm:px-2 py-2 px-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('STATUS')}:</strong>
                      <h6 className="text-gray-700">{startCase(blog?.status) || ""}</h6>
                    </div>
                  </div>
                  
                  <div className="sm:py-4 sm:px-2 py-2 px-2">
                    <div className="relative z-0 w-full group">
                      <strong className="block mb-2">{t('CREATED_DATE')}:</strong>
                      <h6 className="text-gray-700">
                        {blog?.createdAt ? dayjs(blog.createdAt).format("MM-DD-YYYY hh:mm A") : "N/A"}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
        <button 
          className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" 
          type="button" 
          onClick={() => navigate("/blog-management")}
        >
          {t("O_BACK")}
        </button>
      </div>
    </>
  );
};

export default BlogView;